<template>
  <div class="relative z-[100] -mt-6 px-4 md:px-11 pt-20 md:pt-0 pb-6 rounded-t-3xl bg-white flex flex-col snap-start">
    <div class="flex flex-col md:flex-row md:items-center justify-between">
      <div class="p-4">
        <Logo class="h-[51px]" />
      </div>
      <div>
        <a href="https://wa.me/message/N4ONDHXO3EBZG1" target="_blank">
          <img src="@/assets/images/whatsapp-qr.webp" alt="WhatsApp QR Code" />
        </a>
      </div>
      <div class="py-[50px]">
        <p><a class="text-3xl md:text-5xl text-black" href="tel:+41325101385">032 510 13 85</a></p>
        <p><a class="text-3xl md:text-5xl text-black" href="mailto:hello@turbocash.ch">hello@turbocash.ch</a></p>
      </div>
    </div>
    <div class="mt-9 md:ml-4 md:mr-[105px] grid grid-cols-1 md:grid-cols-2">
      <div class="flex flex-col">
        <RouterLink class="mb-9" :to="{ name: 'contact' }">
          <span class="uppercase">{{ t('common.contactUs') }}</span>
        </RouterLink>
        <div>
          <VaButton preset="secondary" border-color="black" color="black" round class="h-[68px] !py-2.5 !pl-2.5 !pr-0" :to="{ name: 'appointment' }">
            <span class="ml-2.5">{{ t('common.bookDemo') }}</span>
            <div class="ml-5 w-[46px] h-[46px] rounded-full bg-red-600 flex flex-col items-center justify-center">
              <ArrowRight class="w-4" />
            </div>
          </VaButton>
        </div>
      </div>
      <div class="mt-10 md:mt-0 flex flex-wrap gap-10">
        <div
          class="flex flex-col gap-6"
          v-for="group in groups"
          :key="group.label"
        >
          <span class="uppercase">{{ group.label }}</span>
          <div class="flex flex-col gap-4">
            <RouterLink
              v-for="link in group.links"
              :key="link.label"
              :to="link.to"
            >
              <span class="uppercase">{{ link.label }}</span>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-[100px] text-center text-neutral-400">
      © ZNIPP GmbH
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Logo from '@/assets/images/logo.svg'
import { useI18n } from 'vue-i18n'
import { VaButton } from 'vuestic-ui'
import ArrowRight from '@/assets/icons/arrow-right.svg'

const { t } = useI18n()

const groups = computed(() => {
  return [
    {
      label: t('footer.navigation'),
      links: [
        { label: t('footer.products'), to: { name: 'products' } },
        { label: t('footer.solutions'), to: { name: 'solutions' } },
        { label: t('footer.pricing'), to: { name: 'pricing' } },
      ],
    },
    {
      label: t('footer.legal'),
      links: [
        { label: t('footer.imprint'), to: { name: 'imprint' } },
        { label: t('footer.terms'), to: { name: 'terms' } },
      ],
    },
    {
      label: t('footer.solutions'),
      links: [
        { label: t('footer.solutionsRetail'), to: { name: 'solutions', params: { industry: 'retail' } } },
        { label: t('footer.solutionsGastronomy'), to: { name: 'solutions', params: { industry: 'gastronomy' } } },
        { label: t('footer.solutionsServices'), to: { name: 'solutions', params: { industry: 'services' } } },
      ],
    },
  ]
})
</script>